import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { SocietyCorporateId } from 'types/Society';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';

import { useShareTitleListPage } from '../context/ShareTitleListPageContext';

const ShareTitleTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = useShareTitleListPage();

  const hasOptions = data.isAdmin && !data.isReadOnly;
  const hasSubtitle = data.corporateId === SocietyCorporateId.AXA;

  const columns = [
    { key: 'number', content: t('Nr') },
    hasSubtitle
      ? {
          key: 'subtitle',
          content: t('Subtitle'),
          hideOnMobile: true,
          className: 'w-20px',
        }
      : null,
    { key: 'partner', content: t('Partner') },
    { key: 'operation', content: t('Operation'), hideOnMobile: true },
    {
      key: 'numeration',
      content: t('Numeration'),
      textPosition: 'center',
      hideOnMobile: true,
      className: 'w-200px',
    },
    {
      key: 'date',
      content: t('date'),
      textPosition: 'center',
      hideOnMobile: true,
    },
    {
      key: 'status',
      content: t('Status'),
      textPosition: 'center',
    },
    {
      key: 'document',
      content: '',
    },
    hasOptions ? { key: 'actions', content: '', textPosition: 'center' } : null,
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default ShareTitleTableHeader;
